var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconExpandRow = function SvgIconExpandRow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56",
    "data-name": "Trazado 56",
    d: "M12,20.182A8.182,8.182,0,1,1,20.182,12,8.182,8.182,0,0,1,12,20.182M12,22a9.954,9.954,0,1,0-7.084-2.915A10,10,0,0,0,12,22Z",
    fill: "#2c7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57",
    "data-name": "Trazado 57",
    d: "M18.768,22.411l-3.147-3.147a.906.906,0,0,0-1.43.1,1,1,0,0,0,.1,1.287L18.1,24.414a.906.906,0,0,0,1.335,0l3.814-3.766a1,1,0,0,0,.1-1.287.906.906,0,0,0-1.43-.1Z",
    transform: "translate(-6.768 -9.393)",
    fill: "#2c7171"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconExpandRow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iconExpandRow.cd2ffe27f02ece0aa3aa3d012d80b585.svg";